// extracted by mini-css-extract-plugin
export var completionBody = "_du-2";
export var completionCard = "_du-0";
export var completionFooter = "_du-3";
export var completionTitle = "_du-1";